angular
  .module('kareo.ui.shared.modules.api.insurance-service', [])
  .factory('insuranceService', ['$http', '$q',
    function insuranceService($http, $q) {
      var createPlanURL = '/patient-mgmt-ui/api/Shared/insuranceCompanyPlan';
      var createCompanyURL = '/patient-mgmt-ui/api/Shared/insuranceCompany';
      var companySearchURL = '/patient-mgmt-ui/api/Shared/SearchInsuranceCompany?companyName=';

      return {
        getCompanySearchURL() {
          return companySearchURL;
        },

        createInsuranceCompanyPlan(plan) {
          return $http.post(createPlanURL, plan).then((response) => {
            return response.data;
          }, (response) => {
            return $q.reject(response.data);
          });
        },

        createInsuranceCompany(company) {
          return $http.post(createCompanyURL, company).then((response) => {
            return response.data;
          }, (response) => {
            return $q.reject(response.data);
          });
        }
      };
    }]);
